import { getAppConfig } from '@utils/getAppConfig'

export function getLoginUrl() {
    const appConfig = getAppConfig()
    const formBaseUrl = appConfig.BASE_FORM_URL

    let formUrl = new URL(formBaseUrl + 'login/')

    formUrl.searchParams.append('pt', 'cards')

    return formUrl.toString()
}
